import Item , { View } from './item'
import listComponent from '@/util/proto/listComponent'
//0-待生成 10-待接单 20-待维修 30-维修中 40-待付款 50-已完成 60-已取消

const repairTypeIcon = [
  {value:0 , label:'world'},
  {value:1 , label:'door'},
]

export default {
  extends: listComponent,
  data() {
    return {
      columns: [
        {
          title: '警员',
          key: 'id',
          minWidth: 300,
          render: (h, { row }) => {

            return (
            <div style="display: flex; align-items: center;">
              <div style="flex: 1 1 auto;">
                <div class="tb-list-item-cell">
                  <div class="tb-list-item-cell-l">
                    <span style="font-size:14px;">{row.name}</span>
                    <span style="font-size: 11px; color: rgba(0, 0, 0, 0.45);">{row.genderText} {row.duties}</span>
                  </div>
                  <div class="tb-list-item-cell-r">
                    <Icon style={{'marginRight':'5px'}} type="md-phone-portrait" />
                    <span>{row.phone}</span>
                  </div>
                </div>
                <div class="tb-list-item-cell">
                  <div class="tb-list-item-cell-l light" style="font-size:12px;">{row.organizationName}</div>
                  <div class="tb-list-item-cell-r">
                    <span title="警号"><Icon custom="i-icon icon-credentials" style="margin-right:5px;" />{row.idcard}</span>
                  </div>
                </div>
              </div>
            </div>
            )
          }
        },

        {
          title: '操作',
          key: 'action',
          width: 160,
          align: 'center',
          render: (h, {row}) => {
            let acts = [
              <a on-click={()=>this.view(row)}>查看</a>,
              <a on-click={()=>this.edit(row)}>编辑</a>,
              <a on-click={()=>this.remove(row)}>删除</a>
            ]
            
            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        name: null,
        phone: null,
        organizationId:null,
      },
      loading: false,
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },
  computed: {
    importUrl() {
      return this.$request.policemanImportUrl()
    }
  },
  methods: {

    search() {
      let { time ,  ...search} = this.params
      if(time && time.length == 2 && time[0] && time[1]){
        search.startDateTime = time[0]
        search.endDateTime = time[1]
      }

      let params = { search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.policemen(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'duties':'job' })
          this.page.total = resp.data.total || 0
        }
      })
    },
    view(row) {
      this.$refs['view'].init(row.id)
    },

    create(row) {
      this.$refs['item'].init(0)
    },

    edit(row) {
      this.$refs['item'].init(row.id)
    },

    remove(row){
      this.$ui.confirm(this.$request.policemanDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.search()
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.search()
    },

    handleUpdate() {
      this.search()
    },
    handleImportComplete(resp) {
      if (resp.code) {
        this.$Modal.warning({ title: '警员导入', content: resp.msg.replace(/[\r\n;]/g, '<br />') })
      } else {
        this.$Notice.success({ title: '导入成功', duration: 20, desc: '您可在 基础设置->导入管理 中查看处理结果！' })
      }
      this.search()
    },
  },
  render() {
    const searchSlots = {
      action:() => {
        return [
          <sl-upload-file style="margin-left:24px;" action={this.importUrl} enable-reply={false} on-complete={this.handleImportComplete} reply-type="modal" error-title="导入失败">
            <template slot="tip">
              <sl-a href="@template/policeman.xlsx" name="警员导入模板.xlsx">模板下载</sl-a>
            </template>
            <Button icon="ios-cloud-upload-outline">导入</Button>
          </sl-upload-file>,
          <Button style="margin-left:8px;" type="primary" icon="md-add" on-click={this.create}>新增</Button>
        ]
      }
    }

    return (
      <sl-page>
        <div class="page-filter">
          <sl-search scopedSlots={searchSlots} col={5} on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <i-input v-model={this.params.name} placeholder="姓名" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.phone} placeholder="电话" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select dict="org" v-model={this.params.organizationId} placeholder="单位" />
            </sl-search-item>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table showHeader={false} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <Item ref="item" on-update={this.search} />
        <View ref="view" />
      </sl-page>
    )
  }
}